import { useCallback, useState } from 'react';
import { SELECTION_A, SELECTION_B } from 'common/constants/valuations';
import {
  PERCENTILE_SELECTION_A_ALIAS,
  PERCENTILE_SELECTION_B_ALIAS,
} from 'pages/Valuations/approaches/guidelinePublicCompanies/constants';
import { ReverseParsedValuationApproachGPC } from 'pages/Valuations/approaches/guidelinePublicCompanies/types';
import { CAP_IQ_TRANSACTION_ID } from 'pages/ValuationsAllocation/approaches/TransactionComps/config/constants';
import {
  OnTransactionCompsSheetChange,
  ReverseParsedValuationApproachGPT,
  TransactionCompsCell,
  TransactionQueryResponse,
} from 'pages/ValuationsAllocation/approaches/TransactionComps/types';
import { transactionIdValidator } from 'pages/ValuationsAllocation/util';
import { useQueryTransaction } from 'services/hooks';

function useCellOptions<T extends ReverseParsedValuationApproachGPC | ReverseParsedValuationApproachGPT>(
  onChange: OnTransactionCompsSheetChange,
  specificApproach: T
) {
  const [cellOptions, setCellOptions] = useState({
    percentile_selection_a: specificApproach.percentile_selection_a,
    [SELECTION_A]: specificApproach.percentile_selection_a,
    percentile_selection_b: specificApproach.percentile_selection_b,
    [SELECTION_B]: specificApproach.percentile_selection_b,
  });

  const { queryTransaction, isLoading } = useQueryTransaction();

  const handleOnChange = useCallback(
    async <T extends TransactionCompsCell>(cell: T, expr: string) => {
      const { alias, isGptRow, isEditableTitleCell, columnId } = cell;
      if ([PERCENTILE_SELECTION_A_ALIAS, PERCENTILE_SELECTION_B_ALIAS].includes(alias)) {
        setCellOptions(prevOptions => ({
          ...prevOptions,
          [cell.alias]: expr,
        }));
      }
      if (isGptRow && (isEditableTitleCell || columnId === CAP_IQ_TRANSACTION_ID) && transactionIdValidator(expr)) {
        const transactionData = await queryTransaction(expr);
        return transactionData as TransactionQueryResponse;
      }
      onChange(cell, expr);
    },
    [onChange, queryTransaction]
  );
  return [cellOptions, handleOnChange, isLoading];
}

export default useCellOptions;
